import { css } from '@emotion/react';

export const dialogStyles = css`
  & .MuiDialog-container:focus-visible > .MuiPaper-root {
    outline: var(--pantry-focus-outline);
    outline-color: var(--pantry-focus-outlineColor);
    outline-offset: var(--pantry-focus-outlineOffset);
  }
`;
